import CharsPerLineField from './parts/CharsPerLineField'
import Divider from './parts/Divider'
import Header from './parts/Header'
import NameField from './parts/NameField'
import PaperWidthField from './parts/PaperWidthField'
import PrintTypeToggles from './parts/PrintTypeToggles'
import SaveButton from './parts/SaveButton'
import TestPrintButton from './parts/TestPrintButton'
import { ColorEnum } from '@/constants/color'
import { AnyConnectionOptions } from '@/features/print/types'
import { OnFormSubmit } from '@/features/settings/components/PrinterConfiguration/form/types'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface ContentProps {
    connectionOptions: AnyConnectionOptions
    onFormSubmit: OnFormSubmit
}

const Content: FC<ContentProps> = ({ connectionOptions, onFormSubmit }) => {
    return (
        <View style={styles.content}>
            <Header />
            <TestPrintButton connectionOptions={connectionOptions} />
            <NameField />
            <Divider />
            <PrintTypeToggles />
            <Divider />
            <View style={styles.twoCol}>
                <CharsPerLineField />
                <PaperWidthField />
            </View>
            <Divider />
            <SaveButton onSubmit={onFormSubmit} />
        </View>
    )
}

const styles = StyleSheet.create({
    content: {
        gap: 24,
        backgroundColor: ColorEnum.GRAY_100,
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_300,
        borderRadius: 8,
        paddingVertical: 32,
        paddingHorizontal: 20,
    },
    twoCol: {
        flexDirection: 'row',
        gap: 16,
        zIndex: 1, // fixes select dropdown menu stacking issue
    },
})

export default Content
